import { createSlice } from '@reduxjs/toolkit'

const miscSlice = createSlice({
  name: 'misc',
  initialState: { data: { routes: {} }, registeredAll: false },
  reducers: {
    setMiscData: (state, action) => {
      state.data = { ...state.data, ...action.payload }
    },
    setRegisteredAll: (state) => {
      state.registeredAll = true
    },
  },
})

export const { setMiscData, setRegisteredAll } = miscSlice.actions
export const miscReducer = miscSlice.reducer
